import { render, staticRenderFns } from "./SendButton.vue?vue&type=template&id=20810333&scoped=true&"
import script from "./SendButton.vue?vue&type=script&lang=js&"
export * from "./SendButton.vue?vue&type=script&lang=js&"
import style0 from "./SendButton.vue?vue&type=style&index=0&id=20810333&prod&lang=scss&"
import style1 from "./SendButton.vue?vue&type=style&index=1&id=20810333&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20810333",
  null
  
)

export default component.exports